 import React, { useEffect, useState } from "react";
import axios from "axios";
import { Base_URL } from "../url";
import NotificationModal from "./NotificationModal";
import "../Styling/Notification.css";
import { useAuth } from "../Context/AuthContext";
import { Bell } from "lucide-react";


const Notifications = () => {
  const { user } = useAuth();
  const orgId = user?.organisationId;
  const [notifications, setNotifications] = useState([]);
  const [upcomingNotifications, setUpcomingNotifications] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (orgId) {
      fetchNotifications();
    }
  }, [orgId]);

  const fetchNotifications = async () => {
    try {
      const res = await axios.get(
        `${Base_URL}/notify/GetNotificationData/${orgId}`
      );
      const allNotifications = res.data || [];
      setNotifications(allNotifications);
      
      // Filter for upcoming 15 days
      const filtered = filterUpcoming15Days(allNotifications);
      setUpcomingNotifications(filtered);
    } catch (error) {
      console.error("Error fetching notifications", error);
    }
  };

  const filterUpcoming15Days = (notifications) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const fifteenDaysFromNow = new Date(today);
    fifteenDaysFromNow.setDate(today.getDate() + 15);

    return notifications.filter((notification) => {
      const notificationDate = new Date(notification.date);
      notificationDate.setHours(0, 0, 0, 0);
      
      return notificationDate >= today && notificationDate <= fifteenDaysFromNow;
    }).sort((a, b) => new Date(a.date) - new Date(b.date));
  };

  const getDaysUntil = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const targetDate = new Date(date);
    targetDate.setHours(0, 0, 0, 0);
    const diffTime = targetDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "Tomorrow";
    return `In ${diffDays} days`;
  };

  const getEventIcon = (eventType) => {
    switch (eventType) {
      case "Birthday":
        return "🎂";
      case "Employee Confirmation":
        return "✅";
      case "Anniversary":
        return "🎉";
      default:
        return "📅";
    }
  };

  return (
    <div className="notification-container">
     <div className="notification-header">
  <div className="header-left-notification">
    <div className="notification-icon-box">
      <Bell size={18} />
    </div>
    <div className="header-text-notification">
      <h6>Upcoming Notifications</h6>
      <span className="notification-count">
        {upcomingNotifications.length} in next 15 days
      </span>
    </div>
  </div>

  <span
    className="view-all-tag-notification"
    onClick={() => setShowModal(true)}
  >
    View all
  </span>
</div>


      <div className="notification-list">
        {upcomingNotifications.slice(0, 8).map((item, index) => (
          <div key={index} className="notification-card">
            <div className="notification-icon">
              {getEventIcon(item.eventType)}
            </div>
            <div className="notification-content">
              <div className="notification-name">{item.resourceName}</div>
              <div className="notification-meta">
                <span className="event-type">{item.eventType}</span>
                <span className="separator">•</span>
                <span className="notify-to">{item.notifyTo}</span>
              </div>
              <div className="notification-template">
                Template: {item.templateType}
              </div>
            </div>
            <div className="notification-date-section">
              <div className="notification-date">
                {new Date(item.date).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </div>
              <div className="days-until">{getDaysUntil(item.date)}</div>
            </div>
          </div>
        ))}

        {upcomingNotifications.length === 0 && (
          <div className="no-data">
            <div className="no-data-icon">📭</div>
            <p>No upcoming notifications in the next 15 days</p>
          </div>
        )}
      </div>

      {showModal && (
        <NotificationModal
          notifications={notifications}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default Notifications;